import {OrderItem} from "../../objects/orders/orderItem";
import {Duty} from "../../objects/calculator/duty";
/**
 * Created by alex.y on 8/31/2017.
 */

export abstract class BaseTaxService{
    public abstract parseTariff(tariff:string) : Duty[];
}


// WEBPACK FOOTER //
// ./app/services/calculator/baseTaxService.ts